module.exports = __webpack_public_path__ + "static/media/plant2.b6fa191a.glb";